import { PrimaryButton } from 'src/editor-v3/components/buttons/primary-button/PrimaryButton';
import { BUTTON_LAYOUTS, BUTTON_SIZES, BUTTON_TYPES } from 'src/editor-v3/components/buttons/button/Button.constants';
import { Share } from 'react-native';
import { AnalyticsEvents } from 'src/_shared/analyticsEvents';
import amplitude from 'src/_shared/amplitude';
import { SourcesEventType } from '@photosi/rn-components/modals/dynamic-modals/modal-upload-multisource/ModalUploadMultisource.constants';
import { logError } from 'src/_shared/logger';
import { isShareApiSupported } from 'src/_shared/utils/is-share-api-supported/isShareApiSupported';
import { ICON_NAMES } from '@photosi/rn-components/icon/icon.helper';
import { neutrals } from 'src/theme/colors';
import { useCallback, useRef } from 'react';
import { ShareButtonProps } from './ShareButton.types';
import useResponsiveScreen from 'src/hooks/useResponsiveScreen';

export const ShareButton = ({
  message,
  url,
  cta,
  shareTokenFamilyAndFriends,
  onPress,
  ...buttonProps
}: ShareButtonProps) => {
  const isShareOnGoing = useRef(false);
  const { isDesktop } = useResponsiveScreen();
  const onPressHandler = useCallback(async () => {
    if (!isShareOnGoing.current) {
      try {
        isShareOnGoing.current = true;
        await Share.share({
          message,
          url,
        });

        amplitude.trackEvent(AnalyticsEvents.dynamicPicker.shareLink, {
          type: 'share',
          share_token_id: shareTokenFamilyAndFriends,
          source_type: SourcesEventType.FamilyFriends,
        });

        await onPress?.();
      } catch (error: any) {
        if (error.toString() !== 'AbortError: Share canceled') logError(error);
      }
      isShareOnGoing.current = false;
    }
  }, [message, url, shareTokenFamilyAndFriends, onPress]);

  return isShareApiSupported() ? (
    <PrimaryButton
      {...buttonProps}
      onPress={onPressHandler}
      layout={BUTTON_LAYOUTS.CENTER}
      type={BUTTON_TYPES.ICON_LEFT}
      iconName={ICON_NAMES.Share}
      iconStyle={{ color: neutrals.white }}
      text={cta}
      size={BUTTON_SIZES.REGULAR}
    />
  ) : (
    <></>
  );
};
